import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'
import { Doughnut } from 'react-chartjs-2'
import { useSelector } from 'react-redux'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import GraphContainer from '../../GraphContainer'

import { useSroiFilters } from '../../../SroiFiltersContext'
import { generateGenderGraphData } from './genderGraphHelpers'
import { getOptions } from './options'
import { getHtmlLegendPlugin } from '../../../../plugins'
import { hasChartData } from '../helpers/chartDataHelpers'

import { gridCharts, helpTexts } from '../../../constants'

import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'

import useStyles from './styles'

const GenderGraph = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { selectedRegion, selectedStakeholder } = useSroiFilters()

  const report = useSelector(socialReturnOnInvestmentReportSelector)

  const graphData = useMemo(() => {
    return generateGenderGraphData({
      selectedRegion,
      selectedStakeholder,
      report
    })
  }, [selectedRegion, selectedStakeholder, report])

  const legendContainerId = useMemo(() => uuidv4(), [])

  const options = useMemo(() => getOptions(legendContainerId), [legendContainerId])

  const plugins = useMemo(() => {
    const htmlLegendPlugin = getHtmlLegendPlugin()

    return [htmlLegendPlugin, ChartDataLabels]
  }, [])

  // Don't render chart if there's no data
  if (!hasChartData(graphData)) {
    return null
  }

  return (
    <GraphContainer
      id={gridCharts.sroiGenderGraph}
      title={t('Impact by Gender')}
      className={classes.genderGraphContainer}
      helpText={helpTexts.impactByGender}
    >
      <div className={classes.graphWrapper}>
        <div className={classes.legendContainer} id={legendContainerId}>
          {/*// The legend of the graph will be rendered here by the plugin*/}
        </div>
        <div>
          <Doughnut data={graphData} options={options} plugins={plugins} />
        </div>
      </div>
    </GraphContainer>
  )
}

export default GenderGraph
